import {useFinesSecurityApi} from "./useFinesSecurityApi";
import qs from "qs";
import dayjs from "dayjs";
import {useContext} from "react";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";

export const useBlackListActions = () => {
    const {GET, POST, PUT} = useFinesSecurityApi();

    async function getBlackList(filters: any) {
        let params = {
            customer: filters.customerName ? filters.customerName : undefined,
            clientType: filters.clientType ? filters.clientType : undefined,
            entryOrigin: filters.entrySource ? filters.entrySource : undefined,
            causal: filters.causal ? filters.causal : undefined,
            taxOrVat: filters.taxOrVat ? filters.taxOrVat : undefined,
            siren: filters.siren ? filters.siren : undefined,
            siret: filters.siret ? filters.siret : undefined,
            entryDateFrom: filters.entryDateFrom ? filters.entryDateFrom : undefined,
            entryDateTo: filters.entryDateTo ? filters.entryDateTo : undefined,
            startDateFrom: filters.startDateFrom ? filters.startDateFrom : undefined,
            startDateTo: filters.startDateTo ? filters.startDateTo : undefined,
            endDateFrom: filters.endDateFrom ? filters.endDateFrom : undefined,
            endDateTo: filters.endDateTo ? filters.endDateTo : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        };

        let data = await GET("fs/blacklist", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data?.total,
            content: data?.data
        };
    }

    async function getBlackListArchived(filters: any) {
        let params = {
            customer: filters.customerName ? filters.customerName : undefined,
            clientType: filters.clientType ? filters.clientType : undefined,
            entryOrigin: filters.entrySource ? filters.entrySource : undefined,
            causal: filters.causal ? filters.causal : undefined,
            taxOrVat: filters.taxOrVat ? filters.taxOrVat : undefined,
            siren: filters.siren ? filters.siren : undefined,
            siret: filters.siret ? filters.siret : undefined,
            entryDateFrom: filters.entryDateFrom ? filters.entryDateFrom : undefined,
            entryDateTo: filters.entryDateTo ? filters.entryDateTo : undefined,
            startDateFrom: filters.startDateFrom ? filters.startDateFrom : undefined,
            startDateTo: filters.startDateTo ? filters.startDateTo : undefined,
            endDateFrom: filters.endDateFrom ? filters.endDateFrom : undefined,
            endDateTo: filters.endDateTo ? filters.endDateTo : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        };

        let data = await GET("fs/blacklist/archived", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data?.total,
            content: data?.data
        };
    }

    async function getBlackListDetail(id: any) {
            let params = { id: id ? id : undefined   }
            let data = await GET("fs/blacklist/single" , true,{
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return data;

    }

    async function getCustomerByButton(id: string | undefined) {
        return await GET("fs/theft-misappropriation/ra/get/"+id, true);

    }

    async function getCausalValues() {
        return await GET("fs/blacklist/causaltypes", true);
    }

    async function getClientType() {
        return await GET("fs/blacklist/clienttypes", true);
    }

    async function getEntrySource() {
        return await GET("fs/blacklist/entryorigins", true);
    }

    async function getFCACodes() {
        return await GET("fs/blacklist/fcacodes", true);
    }

    async function createCustomer(payload: any) {
        return await POST(`fs/blacklist/`, payload, true);
    }

    async function updateCustomer(payload: any) {
        return await PUT(`fs/blacklist`, payload, true)
    }

    async function archiveCustomer(payload: any) {
        let now = dayjs();
        payload.archived_datetime=now;
        payload.date_end_bl = now;
        return await PUT("fs/blacklist", payload, true)
    }

    async function importFile(file: File, name: string) {
        let formData = new FormData();
        formData.append("datatrack", file);
        return await POST("fs/blacklist/datatrack/upload?filename="+name, formData, true, {headers: {"Content-Type": "multipart/form-data"}})
    }

    async function downloadReport() {
        return await GET("fs/blacklist/reports/notarchived", true, {responseType: "blob"})
    }

    async function downloadReportArchived() {
        return await GET("fs/blacklist/reports/archived", true, {responseType: "blob"})
    }


    async function addAttachment(file: File, id: string | undefined) {
        let formData = new FormData();
        formData.append("file", file);
        return await POST("fs/blacklist/attachment/upload?id="+id, formData, true, {headers: {"Content-Type": "multipart/form-data"}})
    }
    async function getSingleAttachment(id: number | undefined,  idBlackList: string | undefined) {
        return await GET("fs/blacklist/attachment/single?id="+id+"&idBlacklist="+idBlackList, true, {responseType: "blob"} );
    }

    async function deleteBlackListAttachment(id: number | undefined, idBlackList: string | undefined) {

        return await GET("fs/blacklist/attachment/delete?id="+id+"&idBlacklist="+idBlackList, true);
    }


    return {
        getBlackList,
        getBlackListArchived,
        getClientType,
        getEntrySource,
        getFCACodes,
        getBlackListDetail,
        addAttachment,
        getSingleAttachment,
        deleteBlackListAttachment,
        createCustomer,
        getCustomerByButton,
        updateCustomer,
        importFile,
        downloadReport,
        downloadReportArchived,
        getCausalValues,
        archiveCustomer
    };
}